// extracted by mini-css-extract-plugin
module.exports = {"vGray4":"#9ba8b1","vGray5":"#bbb","wrap":"Avatar_wrap__2nurg","wrap_unround":"Avatar_wrap_unround__1tkf3","image":"Avatar_image__-AUjE"};